const ASCII_MFA_CODE_PATTERN = /^[0-9]{6}$/;
const ARABIC_INDIC_ZERO = 0x0660;
const PERSIAN_ZERO = 0x06f0;

function normalizedDigit(character: string): string {
  const codePoint = character.codePointAt(0);
  if (codePoint === undefined) return character;
  if (codePoint >= ARABIC_INDIC_ZERO && codePoint <= ARABIC_INDIC_ZERO + 9) {
    return String(codePoint - ARABIC_INDIC_ZERO);
  }
  if (codePoint >= PERSIAN_ZERO && codePoint <= PERSIAN_ZERO + 9) {
    return String(codePoint - PERSIAN_ZERO);
  }
  return character;
}

/**
 * Converts only Arabic-Indic and Persian decimal digits to their ASCII form.
 * All other characters are preserved so validation cannot silently discard
 * unexpected input and turn it into an acceptable MFA code.
 */
export function normalizeMfaDigits(value: string): string {
  return Array.from(value, normalizedDigit).join("");
}

/** Returns the normalized six-digit code, or null for any other input. */
export function validMfaCode(value: string): string | null {
  const normalized = normalizeMfaDigits(value);
  return ASCII_MFA_CODE_PATTERN.test(normalized) ? normalized : null;
}
